import { Lightning as lng, Registry } from '@lightningjs/sdk';
import { CmsBorder } from '../../../components/cms/CmsBorder';
import { Theme } from '../../../config/theme';
import { CmsConstants } from '../../../Business/cms/CmsConstants';
import { CmsActionResolver } from '../../../Business/cms/cardResolver/CmsActionResolver';
import { GuideTranslationKeys } from '../../../api/models/TranslationKeys';

const _constants = {
  marginLeft: 10,
  marginTopTitle: 10,
  marginTopMeta: 45,
  gradientWidth: 40,
  iconsRightMargin: 10,
  iconsBottomMargin: 5,
  metaWidth: 70,
  iconWidth: 24,
};

/**
 * @property {EpgGuideProgramDataSource} datasource
 */
export class GuideProgram extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      Background: {
        w: w => w,
        h: h => h,
        FullColor: {
          w: w => Math.max(0, w - _constants.gradientWidth),
          h: h => h,
          rect: true,
          color: Theme.Colors.Guide.background,
        },
        Gradient: {
          mountX: 1,
          x: w => w,
          w: w => Math.min(w, _constants.gradientWidth),
          h: h => h,
          rect: true,
          colorLeft: Theme.Colors.Guide.background,
          colorRight: Theme.Colors.Guide.programGradient,
        },
      },
      ProgramInfo: {
        clipping: true,
        x: _constants.marginLeft,
        w: w => w - _constants.marginLeft,
        h: h => h,
        Title: {
          y: _constants.marginTopTitle,
          h: h => h,
          text: {
            ...Theme.Fonts.Guide.ProgramTitle,
            text: '',
            wordWrapWidth: w => w,
            wordWrap: false,
            textOverflow: 'ellipsis',
          },
        },
        MetaData: {
          y: _constants.marginTopMeta,
          text: {
            ...Theme.Fonts.Guide.ProgramMeta,
            text: '',
            textColor: Theme.Colors.Primary,
            // wordWrapWidth: w => w,
            // wordWrap: false,
            // textOverflow: 'ellipsis',
          },
        },
        Icons: {
          mount: 1,
          x: w => w - _constants.iconsRightMargin,
          y: h => h - _constants.iconsBottomMargin,
          flex: {
            direction: 'row',
          },
        },
        // MetaTextIconsRow: {
        //   x: _constants.marginLeft,
        //   y: _constants.marginTopMeta,
        //   w: w => w - _constants.marginLeft,
        //   h: h => h - _constants.marginTopMeta,
        //   type: TextIconsRow,
        //   iconsFloatLeft: false,
        // },
      },
      Divider: {
        mountX: 1,
        x: w => w,
        h: h => h,
        w: 3,
        rect: true,
        color: Theme.Colors.Guide.divider,
      },
      Border: {
        x: -CmsConstants.Card.borderSize,
        y: -CmsConstants.Card.borderSize,
        w: w => w + CmsConstants.Card.borderSize,
        h: h => h + CmsConstants.Card.borderSize * 2,
        type: CmsBorder,
        alpha: 0,
      },
    };
  }

  _init() {
    if (this.w !== 0) {
      this.tag('Title').patch({
        text: {
          wordWrapWidth: this.w - _constants.marginLeft * 2,
        },
      });
    }
    if (this.datasource) {
      this.tag('Title').text.text = this.datasource.title;
      this.tag('MetaData').text.text = this.datasource.startTimeString;
      // To ensure a full stage layout (without rendering) -> sets FinalW value
      this.stage.update();
      this.datasource.getEpgIcons().then(res => {
        this.tag('Icons').childList.clear();
        res.forEach((el, i) => {
          if (this._iconsWidth(i + 1) < this.tag('ProgramInfo').finalW) {
            this.tag('Icons').childList.add(el);
          }
        });

        this._checkMetaVisible(res.length);
      });
    } else {
      // no info
      if (this.backend) {
        this.tag('Title').text.text = this.backend.translations.forKey(GuideTranslationKeys.guide_no_information);
      }
      this.tag('MetaData').text.text = '';
      this.tag('Icons').childList.clear();
    }
    if (this.continuesLater) {
      this.patch({
        Background: {
          FullColor: {
            w: w => w,
            color: Theme.Colors.Guide.background,
          },
          Gradient: {
            visible: false,
          },
        },
        Divider: {
          visible: false,
        },
      });
    } else {
      this.patch({
        Background: {
          FullColor: {
            w: w => Math.max(0, w - _constants.gradientWidth),
            color: Theme.Colors.Guide.background,
          },
          Gradient: {
            visible: true,
          },
        },
        Divider: {
          visible: true,
        },
      });
    }
  }

  _focus() {
    this.tag('Border').setSmooth('alpha', 1);
    if (this.datasource) {
      this.datasource.miniDetailData.then(data => {
        if (this.hasFocus()) {
          this.fireAncestors('$updateMiniDetail', data);
          this.fireAncestors('$showMiniDetail');
        }
      });
    }
  }

  _unfocus() {
    this.tag('Border').setSmooth('alpha', 0);
    this.fireAncestors('$hideMiniDetail');
  }

  _active() {
    super._active();
  }

  _iconsWidth(amountIcons) {
    if (amountIcons === 0) {
      return 0;
    }
    return amountIcons * _constants.iconWidth + _constants.iconsRightMargin;
  }

  _checkMetaVisible(amountIcons) {
    // setTimeout else the finalW is not updated
    Registry.setTimeout(() => {
      if (this.tag('ProgramInfo').finalW < _constants.metaWidth + this._iconsWidth(amountIcons)) {
        this.tag('MetaData').visible = false;
      } else {
        // default meta visible
        this.tag('MetaData').visible = true;
      }
    });
  }

  _handleEnter() {
    if (this.datasource) {
      const action = this.datasource.action;
      if (action.extra) {
        action.extra = {
          ...action.extra,
          adult: this.datasource.adult,
        };
      } else {
        action.extra = { adult: this.datasource.adult };
      }
      CmsActionResolver.doAction(this, action, this.datasource.backend);
    }
  }

  /**
   * @param {IFiltersInfo} filter
   */
  updateFilterHighlight(filter) {
    if (!this.datasource || !filter) return;
    let highlightCategory = false;
    let highlightAccessibility = false;
    // check category
    if (filter.categories) {
      const programGenres = this.datasource.genreStrings;
      const intersection = filter.categories.filter(element => programGenres.includes(element));
      highlightCategory = intersection.length === filter.categories.length;
    }
    // check accessibility
    if (filter.accessibility) {
      const accessibilityOptions = this.datasource.accessibilityOptions;
      highlightAccessibility = accessibilityOptions.includes(filter.accessibility);
    }

    let highlight;
    if (filter.accessibility && filter.categories) highlight = highlightCategory && highlightAccessibility;
    else highlight = highlightCategory || highlightAccessibility;
    this.highlight = highlight;
  }

  /**
   * @param {Boolean} state
   */
  set highlight(state) {
    this.tag('Title').text.textColor = state ? Theme.Colors.Primary : Theme.Colors.White;
  }

  /**
   * @param {{ds: EpgGuideProgramDataSource | undefined, continuesLater: boolean | undefined}} d
   */
  set data(d) {
    this.datasource = d.ds;
    this.continuesLater = d.continuesLater;
    this._init();
  }
}
